import { debounce } from "lodash-es";
import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { type CSSProperties, type ChangeEvent, useCallback, useEffect, useId, useState } from "react";
import { useIntl } from "react-intl";
import classNames from "~utils/classNames";

type Props = {
  doSearch: (value: string) => void;
  placeholderIntlKey?: string;
  searchValue?: string;
  initial?: string;
  style?: CSSProperties;
  className?: string;
};

const SearchFilter = ({ doSearch, placeholderIntlKey = "search.two.letters", initial, className, style, searchValue }: Props) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState("");

  const updateSearch = useCallback(
    debounce((searchText) => {
      const trimmedText = searchText.trim();
      doSearch(trimmedText.length > 1 ? trimmedText : "");
    }, 500),
    [doSearch],
  );

  useEffect(() => {
    setValue(searchValue || "");
  }, [searchValue]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    updateSearch(newValue);
  };

  const id = useId();

  return (
    <div className={classNames(className)} style={style}>
      <Input
        allowClear
        type="search"
        name="search"
        id={`search-${id}`}
        value={value}
        defaultValue={initial}
        size="middle"
        placeholder={formatMessage({ id: placeholderIntlKey })}
        onChange={handleChange}
        prefix={<SearchOutlined />}
      />
    </div>
  );
};

export default SearchFilter;
